import {clickEvent} from "../../../webpack/modules/events";

clickEvent('#product-page .open-product-reviews', false, function() {
    let reviews = document.getElementById('reviews-offcanvas');
    let offcanvas = Offcanvas.getOrCreateInstance(reviews);
    offcanvas.show();
});